/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Written_ReportInputs */

const en_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written Report`)
};

const es_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe escrito`)
};

const fr_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport écrit`)
};

const de_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftlicher Bericht`)
};

const ja_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書面によるレポート`)
};

const zh_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`书面报告`)
};

const ar_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقرير مكتوب`)
};

const id_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan Tertulis`)
};

const it_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapporto Scritto`)
};

const ru_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Письменный отчет`)
};

const pt_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório Escrito`)
};

const ko_val_written_report = /** @type {(inputs: Val_Written_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서면 보고서`)
};

/**
* | output |
* | --- |
* | "Written Report" |
*
* @param {Val_Written_ReportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_written_report = /** @type {((inputs?: Val_Written_ReportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Written_ReportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_written_report(inputs)
	if (locale === "es") return es_val_written_report(inputs)
	if (locale === "fr") return fr_val_written_report(inputs)
	if (locale === "de") return de_val_written_report(inputs)
	if (locale === "ja") return ja_val_written_report(inputs)
	if (locale === "zh") return zh_val_written_report(inputs)
	if (locale === "ar") return ar_val_written_report(inputs)
	if (locale === "id") return id_val_written_report(inputs)
	if (locale === "it") return it_val_written_report(inputs)
	if (locale === "ru") return ru_val_written_report(inputs)
	if (locale === "pt") return pt_val_written_report(inputs)
	return ko_val_written_report(inputs)
});